import { createWidget } from '@alfa-bank/site-util-create-widget/create-widget';
import { ModalMobile as Modal } from '@alfalab/core-components-modal/mobile';

import type { TFooterProps, IFooterDeps } from '../models';
import { Footer as Component } from '../footer';
import styles from '../../../modal/mobile/mobile.css';

export const ModalV2FooterMobile = createWidget<IFooterDeps, TFooterProps>({
    Modal,
    styles,
})(Component);
